import React from "react";
import { Container } from "reactstrap";
import { Link as Link2 } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore, { Autoplay, Navigation } from "swiper";
import "../../node_modules/swiper/swiper.scss";
import "../../node_modules/swiper/components/navigation/navigation.scss";
import "../../node_modules/swiper/components/pagination/pagination.scss";

import Image1 from "../assets/images/bg/01.png";
import Image2 from "../assets/images/bg/02.png";
import Image3 from "../assets/images/bg/03.png";

SwiperCore.use([Autoplay, Navigation]);

export default function Hero() {
  // Function to scroll to services section and select specific service
  const scrollToService = (serviceName) => {
    // First scroll to the services section
    const serviceSection = document.getElementById("service");
    if (serviceSection) {
      serviceSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    // After scrolling, trigger the service selection
    setTimeout(() => {
      // Find the service element and click it to select it
      const serviceElements = document.querySelectorAll(".features");
      serviceElements.forEach((element) => {
        const titleElement = element.querySelector("h5");
        if (titleElement && titleElement.textContent === serviceName) {
          element.click();
        }
      });
    }, 500); // Delay to ensure scroll completes
  };

  return (
    <section
      className="swiper-slider-hero position-relative d-block vh-100"
      id="home"
    >
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true }}
        loop
        // navigation
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        speed={2000}
      >
        <SwiperSlide className="d-flex align-items-center overflow-hidden">
          <div
            className="slide-inner slide-bg-image d-flex align-items-center"
            style={{
              backgroundImage: `url(${Image2})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            <div className="bg-overlay"></div>
            <Container>
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="title-heading text-center">
                    <h1 className="display-5 text-white title-dark fw-bold mb-4">
                      Data Engineering <br /> & Analytics Solutions
                    </h1>
                    <p className="para-desc mx-auto text-white-50">
                      Transform your data into actionable insights with our
                      advanced data engineering services. We build robust data
                      pipelines and analytics solutions to drive your business
                      forward.
                    </p>

                    <div className="mt-4 pt-2">
                      <a
                        href="#service"
                        className="btn btn-numantra-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          scrollToService("Data Engineering");
                        }}
                      >
                        Explore Data Solutions
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </SwiperSlide>

        <SwiperSlide className="d-flex align-items-center overflow-hidden">
          <div
            className="slide-inner slide-bg-image d-flex align-items-center"
            style={{
              backgroundImage: `url(${Image1})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            <div className="bg-overlay"></div>
            <Container>
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="title-heading text-center">
                    <h1 className="display-5 text-white title-dark fw-bold mb-4">
                      Applied AI-ML
                    </h1>
                    <p className="para-desc mx-auto text-white-50">
                      Leverage the power of artificial intelligence and machine
                      learning to solve complex business challenges and unlock
                      new opportunities for growth and efficiency.
                    </p>

                    <div className="mt-4 pt-2">
                      <a
                        href="#service"
                        className="btn btn-numantra-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          scrollToService("Applied AI-ML");
                        }}
                      >
                        Discover AI Solutions
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </SwiperSlide>

        <SwiperSlide className="d-flex align-items-center overflow-hidden">
          <div
            className="slide-inner slide-bg-image d-flex align-items-center"
            style={{
              backgroundImage: `url(${Image3})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            <div className="bg-overlay"></div>
            <Container>
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="title-heading text-center">
                    <h1 className="display-5 text-white title-dark fw-bold mb-4">
                      Cloud Engineering Services
                    </h1>
                    <p className="para-desc mx-auto text-white-50">
                      Accelerate your digital transformation with our cloud
                      engineering expertise. We help you architect, migrate, and
                      optimize your infrastructure across AWS, Azure, and Google
                      Cloud.
                    </p>

                    <div className="mt-4 pt-2">
                      <a
                        href="#service"
                        className="btn btn-numantra-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          scrollToService("Cloud Engineering");
                        }}
                      >
                        Start Cloud Journey
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
}
